import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

/**
 * @param {React.Component} ComponentToWrap - component to be enhanced
 * @returns {React.Component} enhanced version of the argument component
 */
export const WithManagedFocuser = (ComponentToWrap) => {
  class HoC extends React.PureComponent {
    static displayName = `WithManagedFocuser(${getDisplayName(ComponentToWrap)})`;
    static propTypes = { isFocused: PropTypes.bool.isRequired };

    constructor(props) {
      super(props);

      this.instanceRef = null;
    }

    componentDidMount() {
      if (this.props.isFocused) {
        this.focusThis();
      }
    }

    componentDidUpdate() {
      if (this.props.isFocused) {
        this.focusThis();
      }
    }

    focusableRef = (ref) => { this.instanceRef = ref; };

    focusThis = () => { this.instanceRef.focus(); }

    render() {
      return (
        <ComponentToWrap
          focusableRef={this.focusableRef}
          focusThis={this.focusThis}
          {...this.props}
        />
      );
    }
  }

  return hoistNonReactStatics(HoC, ComponentToWrap);
};
